import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ConfirmationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ConfirmationModalContainer" */
      './ConfirmationModalContainer'
    ),
  loading: LoadingModal,
});
